import { createFileRoute } from '@tanstack/react-router'
import isNumeric from '@/common/lib/isNumeric'
import SetDemoLauncher from '@/features/demos/components/sets/SetDemoLauncher'
import { titleTagSuffix } from '@/common/constants'
import { Helmet } from '@/common/components/Helmet'

export const Route = createFileRoute(
  '/app/demos/sets/$setId/view/$activeDemoView/',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { setId: setIdParam, activeDemoView } = Route.useParams()
  const setId = isNumeric(setIdParam) ? parseInt(setIdParam, 10) : null

  return (
    <>
      <Helmet>
        <title>Assessment Demo{titleTagSuffix}</title>
        <meta property="og:title" content="Assessment Demo" />
      </Helmet>
      <SetDemoLauncher
        activeDemoView={activeDemoView}
        questionId={null}
        setId={setId}
        showingDemo={true}
      />
    </>
  )
}
